export default __webpack_public_path__ + "static/media/voice_customize.c4e8bab8.png";